<!-- 
create by melody on 2018/11/1 
description:数据字典页面 
-->
<template>
    <div>
       <page-header :title="title"></page-header>
        <div class="table-container">
            <el-button type="primary" plain icon="el-icon-plus" @click="appendFirst()" style="margin-bottom: 20px"> {{$t('m.add')}} </el-button>
            <el-button type="primary" plain icon="el-icon-plus" @click="appendChecked()" style="margin-bottom: 20px"> {{$t('m.addItem')}} </el-button>
            <el-button type="info" plain icon="el-icon-delete" @click="removeChecked()" style="margin-bottom: 20px"> {{$t('m.delete')}} </el-button> 
            <el-tree
                :data="treeData"
                node-key="dicId"
                :expand-on-click-node="false"
                @node-click="clickNode"
                default-expand-all
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }} ({{data.dicCode}})</span>
                    </span>
                 </span>
            </el-tree>
        </div>
        <el-dialog
            :title="$t('m.add')"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                    <!-- <el-form-item label="字典编码" prop="dicCode" style="width: 400px">
                        <el-input v-model="form.dicCode"></el-input>
                    </el-form-item> -->
                    <el-form-item :label="$t('m.dictionaryName')" prop="dicName" style="width: 100%">
                        <el-input  v-model.trim="form.dicName" :maxlength="$inputLengthObj.maxLength1"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" :disabled="addDisable" @click="addDemo()">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.ENUM_MANAGE')
            },
            form: {     //弹框内容
                dicParentCode: '',
                // dicCode: '',
                dicName: '',
            },
            rules: this.$ruleApi.getRule('dataDic'),
            dialogVisible: false,   //控制弹框显示与隐藏
            treeData: [],
            dataDicCodeFlag: '',
            nodeFlag: null,
            defaultProps: {
                code: 'dicCode',
                label: 'dicName',
                dicId: 'dicId'
            },
            addDisable: false
        }
    },
    methods: {
        clickNode(event,node) {
            this.dataDicCodeFlag = event.dicCode
            this.nodeFlag = node
            if(!event.children.length) {
                this.getDemoList(event.dicCode, node)
            }
        },
        appendFirst() {
            this.dialogVisible = true
            this.form = {     //弹框内容
                dicCode: '',
                dicName: ''
            }
            this.dataDicCodeFlag = ''
        },
        append(data) {
            this.dialogVisible = true
            this.form.dicParentCode = data.dicCode
            this.form.dicName = ''
            this.form.dicCode = ''
        },
        appendChecked() {
            if(!this.dataDicCodeFlag) {
                this.$message.info(this.$t('m.chooseDic'))
                return
            }
            this.dialogVisible = true
            this.form.dicParentCode = this.dataDicCodeFlag
            this.form.dicName = ''
            this.form.dicCode = ''
        },
        removeChecked() {
            if(this.dataDicCodeFlag) {
                this.remove(this.nodeFlag,this.nodeFlag.data)
            } else {
                this.$message.info(this.$t('m.chooseDic'))
            }
        },
        getDemoList(code,node) {
            this.$commonFunc.commonRequest('get', '/system/data_dictionary/list/dicCode', 'getDicLineByCode', {dicCode: code})
            .then(res=>{
                if(!res.obj) {
                    return
                }
                if(code) {
                    node.data.children = []
                    res.obj.forEach((o,i)=>{
                        node.data.children.push({dicId: o.dicId, dicName: o.dicName, dicCode: o.dicCode, children: []})
                    })
                } else {
                    this.treeData = []
                    res.obj.forEach((o,i)=>{
                        this.treeData.push({dicId: o.dicId, dicName: o.dicName, dicCode: o.dicCode, children: []})
                    })
                }
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.addDisable = true
            this.$commonFunc.commonRequest('post', '/system/data_dictionary/added', 'addDataDic', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList(this.dataDicCodeFlag, this.nodeFlag)
                this.dataDicCodeFlag = ''
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        remove(node, data) {
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                this.$commonFunc.commonRequest('get', '/system/data_dictionary/deleted?dicIds=' + data.dicId)
                .then(res=>{
                    this.$message.success(this.$t('m.deleteSuccess'))
                    this.dataDicCodeFlag = ''
                    //是一级节点
                    if(node.level == 1) {
                        let deleteFlag 
                        node.parent.data.forEach((o,i)=>{
                            if(o.dicId == data.dicId) {
                                deleteFlag = i
                            }
                        })
                        node.parent.data.splice(deleteFlag, 1)
                    } else { //不是一级节点
                        let deleteFlag 
                        node.parent.data.children.forEach((o,i)=>{
                            if(o.dicId == data.dicId) {
                                deleteFlag = i
                            }
                        })
                        node.parent.data.children.splice(deleteFlag, 1)
                    }
                })
                .catch(res=>{
                    this.$message.error(res.message)
                })
            })
        }
    },
    mounted() {
        this.getDemoList('')
    }
}
</script>
<style scoped>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    padding: 10px;
  }
.el-tree-node__children .custom-tree-node{
    padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/sys/EnumManage.vue